// extracted by css-extract-rspack-plugin
export default {"slideUpWrapper":"SlideUpConsumer-SlideUpWrapper-slideUpWrapper-b72971bc"};